var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "error-template" }, [
            _c("h1", [_vm._v("Oops!")]),
            _vm._v(" "),
            _c("h2", [_vm._v("404 Not Found")]),
            _vm._v(" "),
            _c("div", { staticClass: "error-details" }, [
              _vm._v("Sorry, an error has occured, Requested page not found!")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "error-actions" }, [
              _c(
                "a",
                { staticClass: "btn btn-primary btn-lg", attrs: { href: "/" } },
                [
                  _c("span", { staticClass: "glyphicon glyphicon-home" }),
                  _vm._v("\n            Voltar\n          ")
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }